export const VIEWPORT_PAD = 8;

const DEFAULT_WIDTH = 320;
const DEFAULT_HEIGHT = 380;
const MIN_WIDTH = 280;
const MIN_HEIGHT = 280;
const DEFAULT_BOTTOM_INSET = 16;
const DEFAULT_LEFT_INSET = 16;

export interface DialogRect {
  top: number;
  left: number;
  width: number;
  height: number;
}

export function defaultRect(): DialogRect {
  const vh = typeof window === "undefined" ? 800 : window.innerHeight;
  return {
    top: Math.max(VIEWPORT_PAD, vh - DEFAULT_HEIGHT - DEFAULT_BOTTOM_INSET),
    left: DEFAULT_LEFT_INSET,
    width: DEFAULT_WIDTH,
    height: DEFAULT_HEIGHT,
  };
}

export function clampToViewport(rect: DialogRect): DialogRect {
  const vw = typeof window === "undefined" ? 1280 : window.innerWidth;
  const vh = typeof window === "undefined" ? 800 : window.innerHeight;
  const width = Math.min(
    Math.max(rect.width, MIN_WIDTH),
    vw - VIEWPORT_PAD * 2,
  );
  const height = Math.min(
    Math.max(rect.height, MIN_HEIGHT),
    vh - VIEWPORT_PAD * 2,
  );
  const left = Math.min(
    Math.max(rect.left, VIEWPORT_PAD),
    vw - width - VIEWPORT_PAD,
  );
  const top = Math.min(
    Math.max(rect.top, VIEWPORT_PAD),
    vh - height - VIEWPORT_PAD,
  );
  return { top, left, width, height };
}
